import { Newsletter as NewsletterBase } from "@omni/components/components/Newsletter/newsletter";
import { NewsletterDefault } from "@omni/components/components/Newsletter/newsletter.default";
import { NewsletterProps } from "@omni/types/components/props/newsletter.props";

const NewsletterContainer = ({
    alignment,
    buttonText,
    helperText,
    isBold,
    link
}: NewsletterProps) => {
    return (
        <NewsletterBase
            alignment={alignment}
            buttonText={buttonText}
            helperText={helperText}
            isBold={isBold}
            link={link}
        >
            <NewsletterDefault />
        </NewsletterBase>
    );
};

export { NewsletterContainer };
